import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(private sessionService: AuthService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.includes("assets/") || req.url.includes("/cliente") || req.url.includes("/venta-rapida")) {
      // console.log("public", req);
      return next.handle(req);
    }

    return this.sessionService.getCurrentUser().pipe(
      switchMap(jwtToken => {
        // console.log(`${jwtToken.signInUserSession.idToken.jwtToken}`);
        const authReq = req.clone({
          headers: req.headers.set('Authorization', `${jwtToken.signInUserSession.idToken.jwtToken}`)
        });
        // console.log(authReq);
        return next.handle(authReq);
      }),
      // catchError((error: HttpErrorResponse) => {
      //   if (error.status === 0) {
      //     console.log("No se pudo conectar al servidor. Verifica tu internet.");
      //   }

      //   return throwError(() => error);
      // })
    );
  }
}
